import React from 'react';

import { OrganizationSchema } from '@zola-helpers/client/dist/es/schema/organization';

const renderOrganizationJsonLdScript = () => (
  <script type="application/ld+json">{JSON.stringify(OrganizationSchema)}</script>
);

export default renderOrganizationJsonLdScript;
